<!-- 
程式：ODAVF000.vue
功能：活動導頁
作者：i9400540 施義濃
完成：2020-01-08
-->
<template>
  <div>頁面載入中請稍後...</div>
</template>
<script>
import DTODAV01 from "@/service/DTODAV01.js";

export default {
  name: "ODAVF000",
  data() {
    return {};
  },
  mounted() {
    let actionId = this.$route.query.actionId || "";
    let actInfo = {};
    if (actionId) {
      sessionStorage.setItem("actInfo", "");
      this.$cathayAxios
        .post(DTODAV01.doQueryAction, { act_id: actionId })
        .then(resp => {
          if (resp.returnCode == 0) {
            actInfo = resp.data || {};
            if (!actInfo.act_id) {
              // 去網投首頁
              this.switchContent();
            }
            if (actInfo.login_e == "Y") {
              sessionStorage.setItem("actInfo", JSON.stringify(actInfo));
              window.location =
                window.location.protocol +
                "//" +
                window.location.host +
                "/ODAV/getLoginInfo";
            } else if (actInfo.login_e == "N") {
              this.switchContent(actInfo);
            }
          }else{
            this.switchContent();
          }
        });
    } else {
      // 登入後走的流程
      let jsonStr = sessionStorage.actInfo || "";
      if (jsonStr) {
        actInfo = JSON.parse(jsonStr);
        if (actInfo && actInfo.login_e == "Y") {
          this.switchContent(actInfo);
        }
      } else {
        // 去網投首頁
        this.switchContent();
      }
    }
  },
  methods: {
    switchContent(actInfo) {
      sessionStorage.setItem("actInfo", "");
      // 預設去網投首頁
      let name = "ODAVF101";
      if (actInfo) {
        // 目前已經上線的活動白名單走router "ODAVF102", "spring_2020" 和 "ODAVF100", "WT2020Q1"
        let special = [
          "ODAVF102",
          "spring_2020",
          "ODAVF100",
          "WT2020Q1",
          "ODAVF103",
          "ODAVF109"
        ];
        let isMatch = special.find(function(item) {
          return item == actInfo.page_id;
        });
        name = actInfo.page_id;
        if (!isMatch) {
          // 內容頁
          name = "event";
        }
      }
      this.$router.push({
        name: name,
        query: { id: actInfo ? actInfo.act_id : "" },
        params: { data: actInfo }
      });
    }
  }
};
</script>
<style></style>
